import React, { createContext, useContext, useState, useEffect } from 'react';

const CountryContext = createContext();

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};

export const CountryProvider = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState('Global');
  const [selectedCode, setSelectedCode] = useState('global');

  const countries = [
    { name: "Global", code: "global" },
    { name: "India", code: "in" },
    { name: "Canada", code: "ca" },
    { name: "United States", code: "us" },
    { name: "Australia", code: "au" },
    { name: "New Zealand", code: "nz" },
    { name: "Austria", code: "at" },
    { name: "Finland", code: "fi" },
    { name: "Germany", code: "de" },
    { name: "Ireland", code: "ie" },
    { name: "Netherlands", code: "nl" },
    { name: "Norway", code: "no" },
    { name: "Sweden", code: "se" },
    { name: "Switzerland", code: "ch" },
    { name: "United Kingdom (UK)", code: "gb" },
    { name: "European Countries (General)", code: "eu" },
  ];

  // Load country from localStorage on mount
  useEffect(() => {
    const savedCountry = localStorage.getItem('selectedCountry');
    const savedCode = localStorage.getItem('selectedCountryCode');
    
    if (savedCountry && savedCode) {
      setSelectedCountry(savedCountry);
      setSelectedCode(savedCode);
    }
  }, []);

  const changeCountry = (countryName) => {
    const country = countries.find(c => c.name === countryName);
    if (country) {
      setSelectedCountry(country.name);
      setSelectedCode(country.code);
      localStorage.setItem('selectedCountry', country.name);
      localStorage.setItem('selectedCountryCode', country.code);
    }
  };

  const value = {
    selectedCountry,
    selectedCode,
    countries,
    changeCountry,
  };

  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
};

